import { createAction } from 'redux-actions'

export const clearErrors = createAction('CLEAR_ERRORS')
export const userConfirmationRequest = createAction('USER_CONFIRMATION_REQUEST')
export const userConfirmationResponse = createAction('USER_CONFIRMATION_RESPONSE')
export const userLoginRequest = createAction('USER_LOGIN')
export const userLoginResponse = createAction('USER_LOGIN_RESPONSE')
export const userLogout = createAction('USER_LOGOUT')
export const tokenRetrievalRequest = createAction('TOKEN_RETRIEVAL_REQUEST')
export const tokenRetrievalResponse = createAction('TOKEN_RETRIEVAL_RESPONSE')
export const sessionCleanup = createAction('SESSION_CLEANUP')
export const provisioningRequest = createAction('PROVISIONING_REQUEST')
export const provisioningResponse = createAction('PROVISIONING_RESPONSE')
export const updateProfile = createAction('UPDATE_PROFILE')
export const userinfoClear = createAction('USERINFO_CLEAR')
export const userinfoResponse = createAction('USERINFO_RESPONSE')
